import type {
  SunoPrompt,
  SunoPromptGroup,
  SunoStylePromptHistoryItem
} from '../../../api/suno'
import {
  PromptLibraryPicker,
  StylePromptHistoryDrawer
} from '../PromptManagement'
import { PromptEditorDialog, type PromptEditorState } from '../PromptEditorDialog'

type StylePromptOverlaysProps = {
  historyDeletingId: string | null
  historyError: string | null
  historyItems: SunoStylePromptHistoryItem[]
  historyLoading: boolean
  historyOpen: boolean
  onCloseHistory: () => void
  onClosePromptEditor: () => void
  onClosePromptLibrary: () => void
  onDeleteHistoryItem: (item: SunoStylePromptHistoryItem) => void
  onOpenHistoryItem: (item: SunoStylePromptHistoryItem) => void
  onPromptEditorChange: (value: PromptEditorState) => void
  onPromptLibrarySearch: (search: string) => void
  onPromptLibrarySearchChange: (search: string) => void
  onPromptLibrarySelect: (prompt: SunoPrompt) => void
  onPromptSave: (input: PromptEditorState) => void
  onSuggestPromptMetadata: (input: {
    excludePrompt: string
    stylePrompt: string
  }) => Promise<{ title: string; description: string }>
  promptEditor: PromptEditorState | null
  promptGroups: SunoPromptGroup[]
  promptLibraryError: string | null
  promptLibraryItems: SunoPrompt[]
  promptLibraryLoading: boolean
  promptLibraryOpen: boolean
  promptLibrarySearch: string
  promptLibrarySelectedId: string | null
  promptSaving: boolean
}

export const StylePromptOverlays = ({
  historyDeletingId,
  historyError,
  historyItems,
  historyLoading,
  historyOpen,
  onCloseHistory,
  onClosePromptEditor,
  onClosePromptLibrary,
  onDeleteHistoryItem,
  onOpenHistoryItem,
  onPromptEditorChange,
  onPromptLibrarySearch,
  onPromptLibrarySearchChange,
  onPromptLibrarySelect,
  onPromptSave,
  onSuggestPromptMetadata,
  promptEditor,
  promptGroups,
  promptLibraryError,
  promptLibraryItems,
  promptLibraryLoading,
  promptLibraryOpen,
  promptLibrarySearch,
  promptLibrarySelectedId,
  promptSaving
}: StylePromptOverlaysProps) => (
  <>
    {promptEditor && (
      <PromptEditorDialog
        groups={promptGroups}
        isSaving={promptSaving}
        onCancel={onClosePromptEditor}
        onChange={onPromptEditorChange}
        onGenerateMetadata={onSuggestPromptMetadata}
        onSave={onPromptSave}
        value={promptEditor}
      />
    )}

    {historyOpen && (
      <StylePromptHistoryDrawer
        deletingId={historyDeletingId}
        error={historyError}
        isLoading={historyLoading}
        items={historyItems}
        onClose={onCloseHistory}
        onDelete={onDeleteHistoryItem}
        onOpen={onOpenHistoryItem}
      />
    )}

    {promptLibraryOpen && (
      <PromptLibraryPicker
        error={promptLibraryError}
        isLoading={promptLibraryLoading}
        items={promptLibraryItems}
        onClose={onClosePromptLibrary}
        onSearch={onPromptLibrarySearch}
        onSearchChange={onPromptLibrarySearchChange}
        onSelect={onPromptLibrarySelect}
        search={promptLibrarySearch}
        selectedId={promptLibrarySelectedId}
      />
    )}
  </>
)
